import {fetchApi} from "@julienbdx/nous-sommes-common";

function SetVisibilityCommunaute(endpoint: string | undefined, id: string, oldState: boolean, datePublication: string): any {
    const tochange = !oldState ?
        {
            "visible": true,
            "datePublication": datePublication
        }
        : {
            "visible": false
        }
    const options = {
        method: "PUT",
        credentials: "include",
        body: JSON.stringify(tochange)
    }
    return fetchApi(endpoint, "communautes/" + id, options)
}

export default SetVisibilityCommunaute